<template>
  <GalleryModal
    :customStyle="customStyle"
    :dismissAction="dismissCreateGalleryModal"
    v-if="galleryActiveModal === 'NewGalleryModal'">
    <template slot="header-title">
      <h4>
        <button
          @click.stop="setGalleryActiveModal('ShowGalleriesListModal')"
          class="btn btn-back">
          <i class="fas fa-chevron-left"></i>
        </button>
        สร้างแกลเลอรีใหม่
      </h4>
    </template>
    <template slot="body">
      <!-- ERROR CASE -->
      <div
        class="alert alert-danger"
        v-if="!createGalleryState.isCreated && createGalleryState.error">
        <p>
          มีข้อผิดพลาดเกิดขึ้นขณะสร้างแกลเลอรี <br>
          {{ createGalleryState.error }}
        </p>
      </div>
      <!-- DEFAULT CASE -->
      <div
        class="body-container"
        v-if="!createGalleryState.isCreated">
        <FormGroup>
          <label for="galleryName">ชื่อแกลเลอรี</label>
          <input
            type="text"
            id="galleryName"
            class="form-control"
            placeholder="ตั้งชื่อแกลเลอรี"
            v-model="galleryName">
        </FormGroup>
        <FormGroup>
          <div class="row">
            <div class="col-md-12">
              <button
                class="btn btn-primary btn-create-gallery"
                @click.stop="onCreateGalleryClicked">
                <i class="fas fa-plus"></i> สร้างแกลเลอรีใหม่
              </button>
            </div>
          </div>
        </FormGroup>
      </div>
    </template>
  </GalleryModal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import FormGroup from '@/components/FormGroup.vue';
import GalleryModal from './GalleryModal.vue';

export default {
  data() {
    return {
      customStyle: {
        height: '240px',
      },
      galleryName: '',
    };
  },
  computed: {
    ...mapGetters([
      'createGalleryState',
      'galleryActiveModal',
    ]),
  },
  components: {
    FormGroup,
    GalleryModal,
  },
  methods: {
    ...mapActions([
      'dismissCreateGalleryModal',
      'createGalleryOnModal',
      'loadAllGalleriesForModal',
      'setGalleryActiveModal',
      'resetCreateGalleryState',
    ]),
    async onCreateGalleryClicked() {
      if (this.galleryName.length === 0) {
        this.galleryName = 'Untitled Album';
      }
      await this.createGalleryOnModal(this.galleryName);
      this.galleryName = '';
      this.setGalleryActiveModal('EditGalleryModal');
      this.resetCreateGalleryState();
      await this.loadAllGalleriesForModal(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-create-gallery {
  width: 100%;
}
.btn-back {
  padding: 0 10px 0 0;
}
.success-container {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}
</style>
